import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useTheme } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
// import QuoteStepper from "components/Loans/QuoteStepper";
const QuoteStepper = dynamic(() => import("components/Loans/QuoteStepper"));
import { keyframes } from "@mui/system";
import scroller from "lib/scroller";

export default function QuoteCTA({ postData, scrollID }) {
  const theme = useTheme();
  const [showQuoteStepper, setShowQuoteStepper] = useState(false);

  const url = postData && postData.URL;

  const getCTAText = (url) => {
    let productName = "";

    if (url && url?.includes("dscr-loan")) {
      productName = "DSCR Loan";
      return productName;
    }

    switch (url) {
      case "refinance-rental-property-dscr-loan":
        productName = "DSCR Refinance Loan";
        break;
      case "construction-loan-calculator":
        productName = "Ground up construction Loan";
        break;
      default:
        productName = null; // this makes it so CTA is just ""
      // productName = "DSCR Loan";
    }

    return productName;
  };
  // const productName = getCTAText(url);

  const productName = null;

  return (
    <Box
      sx={{
        display: "flex",
        width: "auto",
        flexDirection: "column",
        [theme.breakpoints.down("md")]: {},
      }}
    >
      <Alert
        severity="success"
        variant="outlined"
        sx={{
          display: "flex",
          margin: theme.spacing(0, 0, 0, 0),
          "& .MuiAlert-message": {
            width: "100% !important",
            [theme.breakpoints.down("md")]: {
              padding: 0,
            },
          },
          [theme.breakpoints.down("md")]: {
            margin: theme.spacing(1, 0, 0, 0),
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            margin: theme.spacing(2, 1),
            [theme.breakpoints.down("md")]: {
              margin: 0,
              flexDirection: "column",
            },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: theme.spacing(4),
              }}
            >
              {productName ? (
                <>
                  Apply for a <b>{productName}</b>
                </>
              ) : (
                <>
                  <b>Loan</b> quote
                </>
              )}
              {/* Apply for a<b> {productName}</b> // option 1, need to do a/b */}
            </Typography>
            <Typography
              component="h2"
              sx={{
                display: "flex",
                width: "auto !important",
                fontSize: theme.spacing(1.5),
                textAlign: "right",
                [theme.breakpoints.down("md")]: {
                  display: "block",
                },
              }}
            >
              * Takes 2 minutes, no credit pull
            </Typography>
          </Box>
          <Button
            sx={{
              margin: theme.spacing(1, 2, 1, "auto"),
              [theme.breakpoints.down("md")]: {
                margin: theme.spacing(1, 2, 1, "auto"),
              },
            }}
            onClick={() => {
              const newState = !showQuoteStepper;
              setShowQuoteStepper(newState);

              if (newState) {
                setTimeout(() => {
                  scroller(`quote_stepper_${scrollID}`, false, -100);
                }, 400);
              }
            }}
            variant="contained"
            color="success"
          >
            Start{" "}
            <Box
              sx={{
                padding: theme.spacing(0, 0, 0, 1),
                fontSize: theme.spacing(2),
                animation: `${keyframes`
                        0% {
                          transform: scale(1.0);
                        }
                        50% {
                          transform: scale(1.88);
                        }
                        100% {
                          transform: scale(1.0);
                        }
                      `} 3s infinite ease`,
              }}
            >
              {" "}
              🚀
            </Box>
          </Button>
        </Box>
      </Alert>
      {showQuoteStepper && (
        <Collapse in={showQuoteStepper} mountOnEnter unmountOnExit>
          <Box id={`quote_stepper_${scrollID}`}>
            {showQuoteStepper && <QuoteStepper scrollID={scrollID} />}
          </Box>
        </Collapse>
      )}
    </Box>
  );
}
